module.exports = __webpack_public_path__ + "img/960.b8376e03.svg";